if (!customElements.get('video-player')) {
  class videoPlayer extends HTMLElement {
    constructor() {
      super();

      this.video = this.querySelector('video');
      this.videoWrapper = this.closest('[data-video-wrapper]');
      this.playButton = this.videoWrapper.querySelector('[data-video-play-trigger]');
      this.overlayImage = this.videoWrapper.querySelector('[data-video-overlay-image]');

      // video and button click
      this.playButton.addEventListener('click', this.playVideo.bind(this));
      this.video.addEventListener('click', this.playVideo.bind(this));
    
    }

    playVideo() {
      this.playButton?.classList.add('hidden');
      this.overlayImage?.classList.add('hidden');
      this.video.play();
    }

  }

  window.videoPlayer = videoPlayer;
  customElements.define('video-player', videoPlayer);
}
